import React from "react";
import { LOGOS } from "../config";
import "./TypingIndicator.css";
import Avatar from "./Avatar";

export default function TypingIndicator({ chat_widget_icon }) {
  return (
    <div className="typing-row">
      <div className="typing-avatar">
        <Avatar
          src={chat_widget_icon || LOGOS.logo}
          alt="Arya"
          className="chat-avatar-img"
        />
      </div>
      <div className="typing-bubble">
        <span className="typing-dot" />
        <span className="typing-dot" />
        <span className="typing-dot" />
      </div>
    </div>
  );
}
